import type { InputProps } from "ra-core";
import { FieldTitle, useInput, useResourceContext } from "ra-core";
import { FormControl, FormError, FormField, FormLabel } from "@/components/admin/form";
import { InputHelperText } from "@/components/admin/input-helper-text";
import { MoedaInput } from "@/components/ui/moeda-input";

/**
 * `MoedaInput` (components/ui/moeda-input.tsx) ligado ao formulário do
 * react-admin. Grava o número em reais (1234.56); vazio grava `null`.
 */
export const MoedaFormInput = (props: InputProps & { placeholder?: string; className?: string }) => {
  const { label, source, helperText, className, placeholder } = props;
  const resource = useResourceContext(props);
  const { id, field, isRequired } = useInput(props);
  const valor = typeof field.value === "number" ? field.value : field.value ? Number(field.value) : null;
  // Fichas antigas guardavam texto livre ("uns 8 mil"); o campo não consegue
  // mostrar isso como número, então o texto aparece embaixo até ser trocado.
  const textoAntigo =
    typeof field.value === "string" && field.value.trim() !== "" && !Number.isFinite(Number(field.value))
      ? field.value
      : null;

  return (
    <FormField id={id} className={className} name={field.name}>
      {label !== false && (
        <FormLabel>
          <FieldTitle label={label} source={source} resource={resource} isRequired={isRequired} />
        </FormLabel>
      )}
      <FormControl>
        <MoedaInput
          id={id}
          name={field.name}
          placeholder={placeholder}
          value={valor != null && Number.isFinite(valor) && !textoAntigo ? valor : null}
          onValueChange={field.onChange}
          onBlur={field.onBlur}
        />
      </FormControl>
      {textoAntigo && <p className="text-xs text-muted-foreground">Registro anterior: {textoAntigo}</p>}
      <InputHelperText helperText={helperText} />
      <FormError />
    </FormField>
  );
};
